<template>
  <div class="inputMain">
    <div class="infoBox">
      <div class="title">
        <div class="titleTop">您兑换的礼品为</div>
        <div class="titleText">“{{ info.skuName }}”</div>
      </div>
      <div v-if="step == 1" class="inputText">请输入地址及收件人信息</div>
      <div v-if="step == 2" class="inputText">请确认收货信息</div>
      <div v-if="step == 1" class="inputBox">
        <div class="input">
          <div class="inputLeft">收件人：</div>
          <input @input="changeInput($event, 'userName')" :value="inputInfo.userName" placeholder="请输入" type="text">
        </div>
        <div class="input">
          <div class="inputLeft">联系电话：</div>
          <input @input="changeInput($event, 'userMobile')" :value="inputInfo.userMobile" placeholder="请输入" type="text">
        </div>
        <div class="input">
          <div class="inputLeft">收货地址：</div>
          <input @input="changeInput($event, 'userAddress')" :value="inputInfo.userAddress" placeholder="省、市、区、街道、楼牌号…"
            type="text">
        </div>
        <div class="address_title"><span>*</span> 填写准确地址以便如期送达您的礼品</div>
        <div v-if="getFillBankCard == 1" class="input">
          <div class="inputLeft">银行卡前六位：</div>
          <input @input="changeInput($event, 'bankCardTopFour')" :value="inputInfo.bankCardTopFour" placeholder="请输入"
            type="text" maxlength="6">
        </div>
        <template v-if="getSpecifyBankSix === 1">
          <div v-if="!specifyBankSixIsCheck" class="form_item_error"><span>*</span> 请输入指定银行的前六位卡号</div>
          <div v-else class="form_item_success"> 该卡号为活动指定银行卡号</div>
        </template>



        <div v-if="getFillBankCard == 1" class="input">
          <div class="inputLeft">银行卡后四位：</div>
          <input @input="changeInput($event, 'bankCardBackSix')" :value="inputInfo.bankCardBackSix" placeholder="请输入"
            type="text" maxlength="4">
        </div>
        <div class="checkBox">
          <div @click="checkClick" class="checkb">
            <div v-if="check" class="circle"></div>
          </div>
          <div class="checkText">本次活动由上海奥维思市场营销服务有限公司提供礼品配送服务，本人同意并授权该公司为前述服务之目的获取及使用本人填写的收件信息。</div>
        </div>

      </div>
      <div v-else-if="step == 2" class="inputBox">
        <div class="toast">信息一旦提交将无法进行修改，请务必仔细核</div>
        <div class="leftText">收件人：<span class="infoText">{{ inputInfo.userName }}</span></div>
        <div class="leftText">联系电话：<span class="infoText">{{ inputInfo.userMobile }}</span></div>
        <div class="leftText">收货地址：<span class="infoText">{{ inputInfo.userAddress }}</span></div>
        <div v-if="getFillBankCard == 1" class="leftText">银行卡前六位：<span class="infoText">{{
          inputInfo.bankCardTopFour
        }}</span></div>
        <div v-if="getFillBankCard == 1" class="leftText">银行卡后四位：<span class="infoText">{{
          inputInfo.bankCardBackSix
        }}</span></div>
      </div>

      <div v-if="step == 3" class="resultBox">
        <img class="resultImg" :src="resSrc" alt="">
        <div class="resultTitle">{{ resTitle }}</div>
        <div class="resultText">{{ resText }}</div>
      </div>

      <template v-if="step == 1">
        <!-- isSkip为1：跳过礼品选择页 -->
        <div v-if="isSkip === '1'" class="button f-jc-c">
          <div @click="comfir" class="buttonRight">确认</div>
        </div>
        <div v-else class="button">
          <div @click="goBack" class="buttonLeft">重新选择礼品</div>
          <div @click="comfir" class="buttonRight">确认</div>
        </div>

      </template>

      <div v-else-if="step == 2" class="button">
        <div @click="rese" class="buttonLeft">重新输入</div>
        <div @click="submit" class="buttonRight">提交</div>
      </div>
      <div v-else-if="step == 3" class="button">
        <div v-if="resCode == '500000018' || resCode == '500000019'" @click="goBack" class="buttonLeft">重新选择礼品</div>
        <!-- <div class="buttonRight">关闭</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant"
import { rsaEndCode, rsaDeCode } from "@/core/utils/utils";
import { queryPost } from "@/core/service/api";

export default {
  name: "inputBox",
  data() {
    return {
      step: 1,
      bankCardInfo: JSON.parse(localStorage.getItem('bankCardInfo')),
      inputInfo: {
        userName: '',
        userMobile: '',
        userAddress: '',
        bankCardTopFour: '',
        bankCardBackSix: '',
      },
      check: false,
      resCode: '',
      resTitle: '',
      resText: '',
      resSrc: '',
      info: this.$route.query,
      codeInfo: {
        '400000046': '提交时间不匹配',
        '400000047': '提交时间和当前时间不匹配',
        '400000048': '兑换码错误',
        '400000049': '兑换码已使用',
        '400000050': '用户已锁定',
        '400000051': '不在活动期内',
        '400000052': '活动已失效',
        '400000053': '兑换的商品不存在',
        '400000054': '超出活动兑换限制',
        '400000055': '兑换码为空',
        '500000017': '太火爆了，礼品兑换失败',
        '500000018': '来晚了，礼品已被兑换',
        '500000019': '库存不足',
      },
      submitType: false,
      isSkip: localStorage.getItem('isSkip') ?? '0'
    };
  },
  computed: {
    getFillBankCard: function () {
      return this.bankCardInfo.fillBankCard
    },
    getSpecifyBankSix: function () {
      return this.bankCardInfo.specifyBankSix
    },
    specifyBankSixIsCheck() {
      // 校验是否符合格式
      return this.checkBankCardTopSix(this.inputInfo.bankCardTopFour)
    }

  },
  methods: {
    rese() {
      this.inputInfo = {
        userName: '',
        userMobile: '',
        userAddress: '',
        bankCardTopFour: '',
        bankCardBackSix: '',
      }
      this.step = 1
    },
    changeInput(e, name) {
      // console.log(e)
      this.inputInfo[name] = e.target.value
    },
    goBack() {
      this.$router.go(-1)
    },
    async submit() {
      const timestamp = new Date().getTime()
      const data = {
        firstBrandId: this.info.firstBrandId,
        projectIntegralId: this.info.projectIntegralId,
        redemptionCode: localStorage.getItem('exChangeCode'),
        batchId: localStorage.getItem('batchCode'),
        timestamp
      }
      // console.log(JSON.stringify(data), localStorage.getItem('pubKey'))
      // console.log(rsaEndCode(localStorage.getItem('pubKey'), JSON.stringify(data)))
      // let test = rsaEndCode(localStorage.getItem('pubKey'),JSON.stringify(data))
      // console.log(rsaDeCode(test),'test')
      const value = {
        key: rsaEndCode(localStorage.getItem('pubKey'), JSON.stringify(data)),
        userMobile: this.inputInfo.userMobile,
        userName: this.inputInfo.userName,
        userAddress: this.inputInfo.userAddress,
        giftId: this.info.skuId,
        giftName: this.info.skuName,
        bankCardTopFour: this.inputInfo.bankCardTopFour,
        bankCardBackSix: this.inputInfo.bankCardBackSix,
        timestamp
      }

      if (this.submitType) return;

      this.submitType = true;

      let res = await queryPost(value, '/isg-projectapplication/gift/exchange/exchangeSubmit')
      this.step = 3
      this.resCode = res.code

      if (res.code == "0") {
        this.resText = res.result.result
        this.resTitle = '提交成功'
        this.resSrc = 'https://frontassets.oss-cn-shanghai.aliyuncs.com/giftExchange/icon_cg.png'
      } else {
        this.resText = res.msg
        this.resTitle = '提交失败'
        this.resSrc = 'https://frontassets.oss-cn-shanghai.aliyuncs.com/giftExchange/icon_sb.png'
      }

      this.submitType = false;
    },

    checkBankCardTopSix(value) {
      let result = false;
      const { specifyBankSix,
        specifyBankSixText } = this.bankCardInfo;

      if (specifyBankSix === 1) {
        const aSpecifyBankSixTexts = specifyBankSixText.split(',');
        for (let i = 0; i < aSpecifyBankSixTexts.length; i++) {
          const element = aSpecifyBankSixTexts[i];
          if (element === value) {
            result = true;
            break;
          }
        }
      } else {
        if (value.length === 6) {
          result = true;
        }
      }
      return result
    },
    comfir() {
      const { fillBankCard, specifyBankSix } = this.bankCardInfo

      if (!this.check) {
        Toast.fail('请先同意并授权获取使用本人收件信息')
        return
      }

      if (fillBankCard == 1 && !this.checkBankCardTopSix(this.inputInfo.bankCardTopFour)) {
        let failText = specifyBankSix === 1 ? "请输入指定银行的前六位卡号" : '请输入正确的银行卡前六位';

        Toast.fail(failText)
        return
      }

      if (fillBankCard == 1 && this.inputInfo.bankCardBackSix.length != 4) {
        Toast.fail('请输入正确的银行卡后四位')
        return
      }
      if (this.inputInfo.userName == '' || !this.inputInfo.userName) {
        Toast.fail('请输入收件人')
        return
      }
      let reg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(19[0-9]{1})|(18[0-9]{1}))+\d{8})$/;

      if (this.inputInfo.userMobile == '' || !this.inputInfo.userMobile) {
        Toast.fail('请输入手机号')
        return
      }
      if (!reg.test(this.inputInfo.userMobile)) {
        Toast.fail('请输入正确的手机号')
        return
      }
      if (this.inputInfo.userAddress == '' || !this.inputInfo.userAddress) {
        Toast.fail('请输入收货地址')
        return
      }

      if (this.inputInfo.bankCardBackSix != '' && this.inputInfo.bankCardBackSix.length != 4) {
        Toast.fail('请输入正确的银行卡后四位')
        return
      }
      this.step = 2
    },
    checkClick() {
      this.check = !this.check
    },
    goPage() {
      this.$store.dispatch({ type: 'start/saveCode', amount: this.$refs.input.value });
      this.$router.push('/giftlist')
    }
  }
};
</script>
<style lang="scss">
.inputMain {
  background: url(https://frontassets.oss-cn-shanghai.aliyuncs.com/giftExchange/bg.png) no-repeat;
  background-color: #BFEFDB;
  background-position: 0 64px;
  background-size: 100% auto;
  min-height: 100vh;
  padding-bottom: 20px;
  padding-top: 142px;
  box-sizing: border-box;

  .f-jc-c {
    justify-content: center !important;
  }


  .infoBox {
    width: 351px;
    // height: 498px;
    padding-bottom: 20px;
    background: url(https://frontassets.oss-cn-shanghai.aliyuncs.com/giftExchange/shxx.png) no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    padding-top: 21px;
    box-sizing: border-box;

    .titleTop {
      color: #868686;
      font-size: 12px;
      margin: 0 auto;
      text-align: center;
    }

    .titleText {
      font-weight: 500;
      font-size: 18px;
      color: #41BA9E;
      margin: 0 auto;
      text-align: center;
    }

    .inputText {
      margin: 44px auto 0;
      font-size: 16px;
      color: #323232;
      text-align: center;
    }

    .inputBox {
      width: 315px;
      margin: 20px auto 0;

      .input {
        display: flex;
        margin-top: 12px;
        justify-content: space-between;
        align-items: center;

        .inputLeft {
          width: 120px;
          text-align: right;
          font-size: 14px;
          color: #646464;
        }

        input {
          border: 0;
          width: 245px;
          height: 38px;
          background: rgba(65, 186, 158, 0.15);
          border-radius: 4px;
          line-height: 38px;
          padding-left: 15px;
          box-sizing: border-box;
          color: #323232;
          font-size: 14px;
        }
      }

      .address_title {
        margin-top: 8px;
        padding-left: 102px;
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #41BA9E;
        line-height: 15px;

        span {
          color: #FF4D4F;
        }
      }

      .form_item_error {
        margin-top: 8px;
        padding-left: 102px;
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FF4D4F;
        line-height: 15px;

        span {
          color: #FF4D4F;
        }
      }

      .form_item_success {
        margin-top: 8px;
        padding-left: 102px;
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #42bb9f;
        line-height: 15px;

        span {
          color: #42bb9f;
        }
      }

      .checkBox {
        display: flex;
        justify-content: space-between;
        font-size: 11px;
        color: #646464;
        margin-top: 30px;

        .checkb {
          width: 20px;
          height: 20px;
          border: 1px solid #41BA9E;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;

          // box-sizing: border-box;
          .circle {
            width: 15px;
            height: 15px;
            background: #41BA9E;
            border-radius: 50%;
          }
        }

        .checkText {
          margin-left: 0;
          width: 280px;
        }
      }

      .toast {
        font-size: 12px;
        color: #41BA9E;
        margin-bottom: 28px;

      }

      .leftText {
        margin-top: 12px;
        font-size: 14px;
        color: #646464;
        display: flex;
        align-items: center;

        .infoText {
          color: #323232;
          width: 240px;
          word-break: break-all;
        }
      }
    }

    .button {
      margin-top: 62px;
      padding-left: 29px;
      padding-right: 29px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      div {
        width: 136px;
        height: 46px;
        border-radius: 23px;
        border: 1px solid #41BA9E;
        font-size: 16px;
        text-align: center;
        line-height: 46px;
      }

      .buttonLeft {
        color: #41BA9E;
      }

      .buttonRight {
        background: #41BA9E;
        color: #F7F0DC;
      }
    }

    .resultBox {
      padding-top: 10px;
      box-sizing: border-box;

      .resultImg {
        width: 86px;
        height: 86px;
        margin: 83px auto 18px;
      }

      .resultTitle {
        margin: 0 auto;
        text-align: center;
        font-size: 18px;
        font-weight: 500;
        color: #323232;
      }

      .resultText {
        margin: 16px auto 0;
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        color: #868686;
      }
    }
  }
}
</style>
